import { Box, Grid, Paper, Typography } from "@mui/material";
import React from "react";

const CardSectionArea = ({ cardDatas }) => {
  return (
    <Box>
      <Grid container spacing={2}>
        {cardDatas.map((card,index) => (
          <Grid item xs={12} sm={6} md={4} lg={2.4} key={index}>
            <Paper
              elevation={4}
              sx={{
                boxShadow:'none',
                background: "linear-gradient(125deg, #51475bff, #792191ff)",
                color: "#fff",
                // borderRadius: 2,
                minHeight: 90,
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                justifyContent: "center",
                p: 2,
                transition: "transform 0.3s ease, box-shadow 0.3s ease",
                // '&:hover': {
                //   transform: 'scale(1.04)',
                //   boxShadow: 'none',
                // },
              }}
            >
              <Typography
                variant="caption"
                sx={{
                  fontWeight: 600,
                  letterSpacing: 1,
                  opacity:1,
                }}
              >
                {card.title}
              </Typography>
              <Typography
                variant="h6"
                sx={{
                  fontWeight: 700,
                  mt: 0.5,
                }}
              >
                {card.value}
              </Typography>
            </Paper>
          </Grid>
        ))}
      </Grid>
    </Box>
  );
};

export default CardSectionArea;
